<template>
  <div>
    <nav class="bar bar-nav">
      <h1 class="title">关注公众号</h1>
    </nav>
    <div class="content">

            <div class="item-content" >
              <div class="item-inner">
                <div style="text-align: center;margin-top: 2rem" >
                  <img src='/emktResources/resocurces/img/publicnumber.jpg' style="height: 100%;width: 100%">
                </div>
                <div class="item-subtitle" style="text-align: center">
                  <p>关注吉凯基因公众号，参与更多精彩活动！</p>
                </div>
              </div>
            </div>

    </div>
  </div>
</template>

<script>
  export default {
    created () {},
    mounted () {},
    data () {
      return {
      }
    },
    computed: {
    },
    methods: {}
  }
</script>

<style scoped>
  .top {
    margin-top: 0.5rem;
  }
  .bottom {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// publicNumber.vue?5adcb51b